<div class="wrapper" *ngIf="serviceTicketStore.displayArticleDetails$ | async">
  <div class="section-title__wrapper">
    <app-assistant-document-detail-view
      (pageChanged)="onPageChanged()"
    ></app-assistant-document-detail-view>
  </div>

  <div class="column">
    <div class="section__wrapper">
      <div
        *ngIf="!articleRated && !(assistantStore.isSelectedDocumentContentError$ | async)"
        class="section__content-inline-narrow"
      >
        <h2>{{ '+SERVICE_TICKET.FEEDBACK_FORM_TITLE' | translate }}</h2>
        <div class="feedback-btns-wrapper">
          <button
            class="feedback-btn"
            data-at-feedback-no-btn
            color="primary"
            mat-stroked-button
            (click)="rateArticle(false)"
          >
            <span>{{ 'GENERAL.BUTTON.NO' | translate }}</span>
          </button>

          <button
            class="feedback-btn"
            data-at-feedback-yes-btn
            color="primary"
            mat-stroked-button
            (click)="rateArticle(true)"
          >
            <span>{{ 'GENERAL.BUTTON.YES' | translate }}</span>
          </button>
        </div>
      </div>

      <div *ngIf="articleRated" class="section__content-inline-centered">
        <h2>{{ '+SERVICE_TICKET.FEEDBACK_FORM_CONFIRMATION' | translate }}</h2>
      </div>
    </div>
    <div class="section__wrapper">
      <h2 class="section__title">
        {{ '+SERVICE_TICKET.ARTICLES_FURTHER_INFORMATION' | translate }}
      </h2>
      <div class="section__content">
        <app-service-ticket-articles-list
          (articleSelected)="onArticleSelected()"
        ></app-service-ticket-articles-list>
      </div>
    </div>
    <div class="section__wrapper">
      <div class="section__content-inline">
        <h2>{{ '+SERVICE_TICKET.ARTICLES_CALL_NOW_TITLE' | translate }}</h2>

        <button
          class="call-btn"
          data-at-call-now-btn
          gtm="onSelect"
          gtmAction="Call now button"
          gtmCategory="ServiceTicket"
          color="primary"
          mat-stroked-button
          (click)="onCallNowClicked()"
        >
          <mat-icon>call</mat-icon>
          <span>{{ '+SERVICE_TICKET.CALL_NOW_BUTTON' | translate }}</span>
        </button>
      </div>
    </div>
  </div>

  <div class="column">
    <div [class.loader--visible]="false" data-at-loader class="section__wrapper loader">
      <h3 class="section__fullwidth">
        <vi-loader [isLoading]="true" [message]="'+GENERAL.LOADING_DATA' | translate"></vi-loader>
      </h3>
    </div>
  </div>
</div>
